// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"cf704717","703":"f6b68ab3"}[chunkId] + ".chunk.js";
};